import { render, staticRenderFns } from "./CustomCardView.vue?vue&type=template&id=780768fa&scoped=true&"
import script from "./CustomCardView.vue?vue&type=script&lang=js&"
export * from "./CustomCardView.vue?vue&type=script&lang=js&"
import style0 from "./CustomCardView.vue?vue&type=style&index=0&id=780768fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780768fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardTitle,VDivider})
